export const MainUrl = "https://phoenix-mea.com/";
